import { AppointmentColor, AppointmentPropsResponseStatusEnum } from '@/apiGenerate/medserver';
import { isYesterdayOrBefore } from './date-utils';

type DateLike = Date | string | number | number[];

export type AppointmentEventColor = {
    backgroundColor: string;
    borderColor: string;
    textColor: string;
    trimColor: string;
};

const TO_VALIDATE_COLOR: AppointmentEventColor = {
    backgroundColor: 'rgba(30, 30, 30, 0.16)',
    borderColor: 'rgba(30, 30, 30, 0.16)',
    textColor: 'rgba(30, 30, 30, 1)',
    trimColor: 'rgba(30, 30, 30, 1)',
};

/**
 * Appointments waiting for validation keep the neutral gray palette regardless of their assigned color.
 * Past appointments (end/start before now) switch to the color's disabled palette.
 * Everything else uses the color's active palette.
 */
export const getAppointmentEventColor = (
    color: AppointmentColor | undefined,
    status: AppointmentPropsResponseStatusEnum | undefined,
    start?: DateLike | null,
    end?: DateLike | null
): AppointmentEventColor => {
    if (status === AppointmentPropsResponseStatusEnum.ToValidate) {
        return TO_VALIDATE_COLOR;
    }

    if (isYesterdayOrBefore(new Date(end.toString())) || status === AppointmentPropsResponseStatusEnum.Honoured) {
        return {
            backgroundColor: color?.disabledBackgroundColor,
            borderColor: color?.disabledBackgroundColor,
            textColor: color?.disabledTextColor,
            trimColor: color?.disabledTrimColor,
        };
    }

    return {
        backgroundColor: color?.backgroundColor,
        borderColor: color?.backgroundColor,
        textColor: color?.textColor,
        trimColor: color?.trimColor,
    };
};
